import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListIntroducer = (params) => sendGet("/introducers", params);
export const createIntroducer = (params) => sendPost("/introducers", params);

export const updateIntroducer = (id, params) =>
  sendPut(`/introducers/${id}`, params);

export const deleteIntroducer = (id) => sendDelete(`/introducers/${id}`);
